import { render } from "./UsuarioCadastro.vue?vue&type=template&id=0454124e&scoped=true&ts=true"
import script from "./UsuarioCadastro.vue?vue&type=script&lang=ts"
export * from "./UsuarioCadastro.vue?vue&type=script&lang=ts"

import "./UsuarioCadastro.vue?vue&type=style&index=0&id=0454124e&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0454124e"]])

export default __exports__